module.exports = __webpack_public_path__ + "static/media/motion-design.374a4d86.png";